import { css, cx } from '@linaria/atomic';
import type { InlineLabelPlacement } from './types';

const baseBoolLayout = css`
  display: flex;
  align-items: flex-start;
`;

const baseBoolLayoutLabelLeft = css`
  align-items: center;
  flex-direction: row-reverse;

  label {
    width: 100%;
  }
`;

export const getBaseBoolLayoutClassName = (labelPlacement?: InlineLabelPlacement) =>
  cx(baseBoolLayout, labelPlacement === 'left' && baseBoolLayoutLabelLeft);
